import React from 'react'
import mainBannerMobile from '../../../assets/images/front/main-banner-mobile.png'
import mainBannerDesktop from '../../../assets/images/front/main-banner-desktop.png'
import hpBannerGraphicsMobile from '../../../assets/images/front/svg/hp-banner-graphics-mobile.svg'
import signpostImage1 from '../../../assets/images/front/hp/signpost-1.png'
import signpostImage2 from '../../../assets/images/front/hp/signpost-2.png'
import signpostImage3 from '../../../assets/images/front/hp/signpost-3.png'
import experienceIcon from '../../../assets/images/front/svg/experience.svg'
import individualIcon from '../../../assets/images/front/svg/individual.svg'
import effectiveIcon from '../../../assets/images/front/svg/efective.svg'
import lecturersIcon from '../../../assets/images/front/svg/lectors.svg'
import Reviews from '../../../components/Front/Reviews/Reviews'
import Partners from '../../../components/Front/Partners/Partners'
import HomepageSlider from '../../../components/Front/HomepageSlider/HomepageSlider'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import { getSettings } from '../../../moduls/settings'
import { useQuery } from 'react-query'
import { Settings } from '../../../services/types'
import OwlBanner from '../../../components/Front/OwlBanner/OwlBanner'

const Homepage: React.FC = () => {
  const history = useHistory()

  const { data: settings } = useQuery<Settings>(['settings'], getSettings)

  return (
    <div className="HP">
      <div className="w-full max-w-[1000px] mx-auto">
        <div className="max-w-[1000px] mx-auto lg:px-4 mt-[52px] lg:mt-[84px] bg-[#F5FAFF] lg:bg-white">
          <div
            className={'grid grid-cols-12 gap-4 bg-cover bg-center w-full rounded-b-3xl'}
            style={{ backgroundImage: `url(${mainBannerDesktop})` }}
          >
            <div className="col-span-12 lg:col-span-6 h-[300px] lg:h-auto">
              <img src={mainBannerMobile} alt="" className="min-w-screen lg:hidden rounded-b-3xl" />
              <img
                src={hpBannerGraphicsMobile}
                alt=""
                className="absolute top-65 left-[50%] translate-x-[-50%] lg:hidden"
              />
            </div>
            <div className="col-span-12 lg:col-span-6 grid grid-cols-12 gap-4 py-5 px-4">
              <div className="col-span-6 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300 rounded-3xl">
                <span
                  className="cursor-pointer frame-2 flex flex-col items-center justify-center w-full hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                  onClick={() => history.push(routesURLs.pkAll)}
                >
                  <img
                    className="snimek-obrazovky mb-2"
                    src="https://c.animaapp.com/mbyttqkuyMhIPB/img/sni-mek-obrazovky-2025-04-24-v-14-45-40-1.png"
                  />
                  <div className="kurzy-k-p-ij-ma-k-m">
                    Kurzy
                    <br />k přijímačkám
                  </div>
                </span>
              </div>
              <div className="col-span-6 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300 rounded-3xl">
                <span
                  className="cursor-pointer frame-5 flex flex-col items-center justify-center w-full hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                  onClick={() => history.push(routesURLs.pnAll)}
                >
                  <div className="group-wrapper flex items-center justify-center mb-2">
                    <img
                      className="group"
                      src="https://c.animaapp.com/mbyttqkuyMhIPB/img/group-1.png"
                    />
                  </div>
                  <div className="p-ij-ma-ky-nane-isto">
                    Přijímačky
                    <br />
                    nanečisto
                  </div>
                </span>
              </div>
              <div className="col-span-6 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300 rounded-3xl">
                <span
                  onClick={() => history.push(routesURLs.onlineSchool)}
                  className="cursor-pointer frame-3 flex flex-col items-center justify-center w-full hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                >
                  <img
                    className="snimek-obrazovky mb-2"
                    src="https://c.animaapp.com/mbyttqkuyMhIPB/img/sni-mek-obrazovky-2025-04-24-v-14-44-52-1.png"
                  />
                  <div className="text-wrapper">on-line škola</div>
                </span>
              </div>
              <div className="col-span-6 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300 rounded-3xl">
                <span
                  className="cursor-pointer frame-4 flex flex-col items-center justify-center w-full hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                  onClick={() => history.push(routesURLs.privateClass)}
                >
                  <img
                    className="snimek-obrazovky mb-2"
                    src="https://c.animaapp.com/mbyttqkuyMhIPB/img/sni-mek-obrazovky-2025-04-24-v-14-44-06-1.png"
                  />
                  <div className="text-wrapper-2">osobní doučování</div>
                </span>
              </div>
            </div>
          </div>
        </div>
        {settings?.small_tiles && (
          <div className="px-4 lg:px-0">
            <div className="container mx-auto px-4 my-12">
              <div className="grid grid-cols-12 gap-4 mx-auto max-w-[820px]">
                <div className="col-span-12">
                  <h2 className="text-center text-[#0183BA] text-[25px] leading-tight">
                    S námi Vás u přijímaček nic nepřekvapí!
                  </h2>
                </div>
                <a
                  href={settings.small_tiles[0].url}
                  target='_blank'
                  className="col-span-12 md:col-span-4 relative text-white text-lg leading-none rounded-3xl hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300"
                >
                  <img
                    src={settings.small_tiles[0].image}
                    alt=""
                    className="w-full h-auto object-cover rounded-3xl"
                  />
                  <span className="block w-full py-2 bg-[#A8CD00] px-4 absolute bottom-0 left-0 rounded-b-3xl text-center">
                    {settings.small_tiles[0].title}
                  </span>
                </a>
                <a
                  href={settings.small_tiles[1].url}
                  target='_blank'
                  className="col-span-12 md:col-span-4 relative text-white text-lg leading-none rounded-3xl hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300"
                >
                  <img
                    src={settings.small_tiles[1].image}
                    alt=""
                    className="w-full h-auto object-cover rounded-3xl"
                  />
                  <span className="block w-full py-2 bg-[#00A0E3] px-4 absolute bottom-0 left-0 rounded-b-3xl text-center">
                    {settings.small_tiles[1].title}
                  </span>
                </a>
                <a
                  href={settings.small_tiles[2].url}
                  target='_blank'
                  className="col-span-12 md:col-span-4 relative text-white text-lg leading-none rounded-3xl hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.2)] transition-shadow duration-300"
                >
                  <img
                    src={settings.small_tiles[2].image}
                    alt=""
                    className="w-full h-auto object-cover rounded-3xl"
                  />
                  <span className="block w-full py-2 bg-[#A8CD00] px-4 absolute bottom-0 left-0 rounded-b-3xl text-center">
                    {settings.small_tiles[2].title}
                  </span>
                </a>
              </div>
            </div>
          </div>
        )}
        <OwlBanner settings={settings as Settings} />
      </div>
      <Reviews />
      <div className="px-4 lg:px-0">
        <div className="container mt-[30px] md:mt-[60px] px-4">
          <div className="max-w-[720px] mx-auto">
            <p className="text-center mb-10">
              Zlepšujeme žákům jejich znalosti a prospěch napříč všemi ročníky ZŠ. Pomáháme jim
              uspět u jednotných přijímacích zkoušek Cermat na střední školy a to vše efektivně a
              bez zbytečného stresu.
            </p>
            <div className="grid grid-cols-12">
              <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                <div className="h-12 mb-3">
                  <img src={experienceIcon} alt="" />
                </div>
                <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                  Více než 10 let <br />
                  zkušeností
                </span>
              </div>
              <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                <div className="h-12 mb-3">
                  <img src={individualIcon} alt="" />
                </div>
                <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                  Individuální <br />
                  přístup
                </span>
              </div>
              <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                <div className="h-12 mb-3">
                  <img src={effectiveIcon} alt="" />
                </div>
                <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                  Nejefektivnější <br />
                  vyučovací metody
                </span>
              </div>
              <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                <div className="h-12 mb-3">
                  <img src={lecturersIcon} alt="" />
                </div>
                <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                  Několik desítek <br />
                  zkušených lektorů
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <HomepageSlider />
      <Partners />
    </div>
  )
}

export default Homepage
